<div class="sections" [class.extended]="extendDocument">

    <div class="document-container">
        <iframe [src]="safeDocumentUrl" class="flex-fill w-100" frameborder="0"></iframe>
    </div>

    <div class="divider">
        <app-icon src="chevron" class="se-icon-button expand-main-section-button" [class.extended]="extendDocument" (click)="extendDocument = !extendDocument"></app-icon>
    </div>

    <div>
        <div>
            <div class="info">
                <ng-container *ngIf="applicationStatus === 'pending'">
                    <p *ngIf="downloadAvailable">
                        This document will be deleted in: <strong>{{ downloadTimer$ | async }}</strong><br>
                        Until then, you can <strong>download</strong> this file by pressing the <app-icon src="download" class="text-icon"></app-icon> button above the document.
                    </p>
                    <p *ngIf="!downloadAvailable">
                        This document is no longer available ion our system.<br>
                        You can <strong>download</strong> this file as long as you don't refresh the page by pressing the <app-icon src="download" class="text-icon"></app-icon> button above the document.
                    </p>
                </ng-container>
                <ng-container *ngIf="applicationStatus === 'created'">
                    <p *ngIf="requiresGuarantorSignature && !signatures.guarantor?.submitted">
                        In the meantime, you may review the document and assure that all information in the document is valid.
                    </p>

                    <p *ngIf="!requiresGuarantorSignature || signatures.guarantor?.submitted">
                        Once you submit, your application will be sent to our partner. You can view any updates in the Business tab on the Settings page, and you'll receive email notifications about any changes or approvals.
                    </p>

                    <p class="note" *ngIf="requiresGuarantorSignature">
                        Note: Changing information in the form, revoking or updating the signature will require a new signature from the guarantor.
                    </p>
                </ng-container>
            </div>
        </div>
        <div class="actions">
            <ng-container *ngIf="(!requiresGuarantorSignature || signatures.guarantor?.submitted) && applicationStatus === 'created'">
                <div class="form-checkbox w-100">
                    <mat-checkbox [formControl]="submitCheckboxControl" color="primary" (change)="signatureApprovalClick($event)"></mat-checkbox>
                    <p style="text-wrap: balance; text-wrap: pretty;">I reviewed the document, confirm that all the information provided is valid and I agree to send it to Nuvei.</p>
                </div>
                <loader-button style="width: 100%; max-height: 44px"
                               [loading]="waitingForDocumentApproval || submitting"
                               [disabled]="!formDocument?.documentApproval"
                               text="Submit"
                               (onClick)="submit()"
                ></loader-button>
            </ng-container>

            <loader-button style="width: 100%; max-height: 44px" *ngIf="applicationStatus === 'pending'"
                           text="Close"
                           routerLink="/lobby"
            ></loader-button>
        </div>
    </div>

</div>